import './TimelineFilters.scss';
import { COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
import { getTimelineSummarySelector } from '@timeline/@arch/selectors';
import React from 'react';
import { TimelineFilterSection } from './FilterSection';
import { ApplicationFilter } from './ApplicationFilter';
import { ChangeRecordsFilter } from './ChangeRecordsFilter';
import { DisplayNameFilter } from './DisplayNameFilter';
import { FeatureFlag } from '@sonar-software/sonar-core';
import { FollowingFilter } from './FollowingFilter';
import { ModifiedByFilter } from './ModifiedByFilter';
import { SystemChangesFilter } from './SystemChangesFilter';
import { TagFilter } from './TagFilter';
import { useCurrentUser, useSonarSelector } from '@hooks';
export const TimelineFilters = ({ clearSelectedChangeType, highlightedChangeType, onChange, params, selectedChangeType }) => {
    var _a;
    const summary = useSonarSelector(getTimelineSummarySelector.data);
    const disabled = !Object.keys((_a = summary === null || summary === void 0 ? void 0 : summary.changeCounts) !== null && _a !== void 0 ? _a : {}).length;
    const { isReadOnly } = useCurrentUser();
    return (React.createElement("div", { className: 'timeline-filters' },
        React.createElement(TimelineFilterSection, { title: COPY_SPECIFIC.DISPLAY_NAME },
            React.createElement(DisplayNameFilter, { disabled: disabled, onChange: onChange, value: params.objectNameFilter })),
        React.createElement(TimelineFilterSection, { title: COPY_SPECIFIC.MODIFIED_BY },
            React.createElement(ModifiedByFilter, { disabled: disabled, onChange: onChange, value: params.modifiedByUsernames })),
        React.createElement(TimelineFilterSection, { title: COPY_SPECIFIC.TAG },
            React.createElement(TagFilter, { disabled: disabled, onChange: onChange, value: params.tagIds })),
        React.createElement(TimelineFilterSection, { featureFlag: FeatureFlag.DataSecurityDashboard, title: COPY_SPECIFIC.MONITORED_APPLICATIONS },
            React.createElement(ApplicationFilter, { disabled: disabled, onChange: onChange, value: params.applicationIds })),
        React.createElement(TimelineFilterSection, { featureFlag: FeatureFlag.Followers, hidden: isReadOnly, title: COPY_SPECIFIC.FOLLOWING },
            React.createElement(FollowingFilter, { disabled: disabled, onChange: onChange, value: params.isFollowing })),
        React.createElement(TimelineFilterSection, null,
            React.createElement(SystemChangesFilter, { checked: !params.system, disabled: disabled, onChange: onChange })),
        React.createElement(TimelineFilterSection, null,
            React.createElement(ChangeRecordsFilter, { clearSelectedChangeType: clearSelectedChangeType, highlightedChangeType: highlightedChangeType, onChange: onChange, params: params, selectedChangeType: selectedChangeType }))));
};
